import Axios, { AxiosRequestConfig, AxiosError } from "axios";
import { LOGIN_ROUTE } from "./routes";
import { AUTH_TOKEN_KEY } from "./shared";
import { getApiBaseUrl } from "./utils";

const apiBaseUrl = getApiBaseUrl();

console.log("apiBaseUrl be:", apiBaseUrl);

export const AXIOS_INSTANCE = Axios.create({
  baseURL: apiBaseUrl,
});

AXIOS_INSTANCE.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = LOGIN_ROUTE;
      localStorage.removeItem(AUTH_TOKEN_KEY);
    }
    return Promise.reject(error);
  }
);

//NB: don't know if these exports are needed for orval...
//having ts-unused-exports b/c atow it's easier
// ts-unused-exports:disable-next-line
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
  }).then(({ data }) => data);

  return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this

// ts-unused-exports:disable-next-line
export type ErrorType<Error> = AxiosError<Error>;
// In case you want to wrap the body type (optional)
// (if the custom instance is processing data before sending it, like changing the case for example)
// wtf I shouldn't have to define this
// ts-unused-exports:disable-next-line
export type BodyType<BodyData> = BodyData;
